define('pages/claim/OccurrenceCode/OccurrenceCodeComponent',[
	'core/can',
	'models/OccurrenceCode',
	'template!pages/claim/OccurrenceCode/OccurrenceCodeView.stache',
	'moment'
], function(can, OccurrenceCode, template, moment) {
	
	// TODO less jquery, more canjs
	
	function makeOccurenceCodeList(codes, fls, visible) {
		
		// Create List
		var listForDisplay = new OccurrenceCode.List;
		for (var i=0; i<fls.length; i++) {
			var code = codes.attr(i),
				exists = (code !== undefined);
			listForDisplay.push(can.extend({
				FieldLocator: fls[i],
				isHidden: !exists && (i > visible-1),
			}, exists ? code.attr() : {}));
		}
		
		// Bind to Claim
		listForDisplay.bind('change', function() {
			var listForModel = [];
			this.each(function(code) {
				if (code.attr('Code') ||
					code.attr('Date') ||
					code.attr('FromDate') ||
					code.attr('ToDate')) {
					
					var o = code.attr();
					delete o.FieldLocator;
					delete o.isHidden;
					listForModel.push(o);
				}
			});
			codes.replace(listForModel);
		});
		
		return listForDisplay;
	}
	
	function getRoot(el) {
		return el.closest('#OccurrenceCodes, #OccurrenceSpanCodes');
	}
	
	function isEmpty(code) {
		return !(code.attr('Code') || code.attr('FromDate') || code.attr('ToDate'));
	}
	
	return can.Component.extend({
	
		tag: 'claim-occurrencecodes',
		
		template: can.view(template),
	
		scope: function(attrs, scope, el) {
			return {
				
				isOccurrenceCodesOpen: false,
				
				isOccurrenceSpanCodesOpen: false,

				OccurrenceCodes: makeOccurenceCodeList(
					attrs.claim.attr('OccurrenceCodes'), 
					['31a','32a','33a','34a','31b','32b','33b','34b'],
					attrs.visible
				),
				
				OccurrenceSpanCodes: makeOccurenceCodeList(
					attrs.claim.attr('OccurrenceSpanCodes'),
					['35a','36a','35b','36b'],
					attrs.visible
				),
				
				Today: moment().format()
			}
		},
		
		events: {
			
			'.codes-open click': function(el, ev) {
				var $codes = getRoot(el);
				this.scope.attr('is'+$codes.attr('id')+'Open', true);
			},
			
			'.codes-more click': function(el, ev) {
				var $codes = getRoot(el),
					codes = this.scope.attr($codes.attr('id'));
				codes.each(function(code) {
					code.attr('isHidden', false);
				});
			},
			
			'.codes-collapse click': function(el, ev) {
				var $codes = getRoot(el),
					codes = this.scope.attr($codes.attr('id'));
				for (var i=codes.attr('length')-1; i>=0; --i) {
					var code = codes.attr(i);
					if (!code.attr('Code')) {
						if (i===0) {
							this.scope.attr('is'+$codes.attr('id')+'Open', false);
						} else {
							code.attr('isHidden', true);
						}
					} else {
						break;
					}
				}
			},
			
			'.show-codes click': function(el, ev) {
				el.hide().next().show().find('input').first().focus();
			},
			
			'.more-codes click': function(el, ev) {
				var $codes = getRoot(el);
				this.scope.attr($codes.attr('id')).each(function(code) {
					code.attr('isHidden', false);
				});
				el.closest('tr').hide();
			},
			
			'.collapse-codes click': function(el, ev) {
				
				var $codes = getRoot(el),
					codes = this.scope.attr($codes.attr('id'));
				for (var i=codes.attr('length')-1; i>=0; --i) {
					var code = codes.attr(i);
					if (isEmpty(code)) {
						if (i===0) {
							$codes
								.find('.show-codes').show()
								.next().hide()
								.find('.more-codes').closest('tr').show()
						} else {
							code.attr('isHidden', true);
						}
					} else {
						break;
					}
				}
			}
		}
	});
});
